import { BrowserModule } from '@angular/platform-browser';
import { NgModule, isDevMode, ErrorHandler } from '@angular/core';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { InsightsWaitComponent } from './analysis/insights-wait.component';
import { UserModule } from './user/user.module';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { LinqCanvasModule } from './canvas/linq.canvas.module';
import { MaterialModule } from './material/material.module';
import { OrganisationModule } from './organisation/organisation.module';
import {LINQUtilsModule} from "./linq-utils/linq-utils.module";
import { LayoutModule } from '@angular/cdk/layout';
import { ModelLayoutModule } from './layouts/layouts.module';
import { ModelComponentsModule } from './model-components/model-components.module';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { ServiceWorkerModule } from '@angular/service-worker';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { MsalBroadcastService, MsalGuard, MsalInterceptor, MsalModule, MsalRedirectComponent, MsalService } from '@azure/msal-angular';
import { msalConfig } from './user/auth-config';
import { environment } from '../environments/environment';
import { OnboardingComponent } from './ui-components/onboarding/onboarding.component';
import { UIComponentsModule } from './ui-components/ui-components.module';
import { ExceptionAndLoggingService } from './linq-utils/logging/exception-logging-service';
import { AnimationModule } from './animations/animations-module';
import { SocialLoginModule, SocialAuthServiceConfig, SOCIAL_AUTH_CONFIG } from '@abacritt/angularx-social-login';
import {
  GoogleLoginProvider,
//  FacebookLoginProvider
} from '@abacritt/angularx-social-login';

@NgModule({ 
    declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent, MsalRedirectComponent], 
    //bootstrap: [AppComponent], 
    imports: [
        OnboardingComponent,
        InsightsWaitComponent,
        AnimationModule,
        ModelLayoutModule,
        ModelComponentsModule,
        UserModule,
        OrganisationModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        CommonModule,
        LinqCanvasModule,
        UIComponentsModule,
        MsalModule,
        LINQUtilsModule,
        SocialLoginModule,
        MaterialModule,
        LayoutModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode(),
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        }),        
        MsalModule.forRoot(new PublicClientApplication(msalConfig), 
        {
            interactionType: InteractionType.Redirect,
            authRequest: {
                scopes: environment.apiConfig.scopes,
            }
        },
        {
            interactionType: InteractionType.Redirect,
            protectedResourceMap: new Map([
                [environment.apiConfig.uri, environment.apiConfig.scopes],
                [environment.urlAddress + '/api', null] // turn off inceptor, will do it manually using cookies
                //['http://localhost:3000/api', ['api://16b79f7c-5aa6-4165-b495-8fe27bd3696a/linq-development-api']]
            ])
        })
    ],
    providers: [
        {
            // the same service that handles server errors, so they share the limits on reporting and showing errors
            provide: ErrorHandler,
            useExisting: ExceptionAndLoggingService,
        },
        {
            provide: SOCIAL_AUTH_CONFIG,
            useValue: {
                autoLogin: false,
                lang: 'en',
                providers: [
                    {
                        id: GoogleLoginProvider.PROVIDER_ID,
                        provider: new GoogleLoginProvider(
                            environment.googleClientID, {
                            scopes: 'email profile openid',
                            oneTapEnabled: false
                        })
                    }
                ],
                onError: (err) => {
                    console.error("************************error creating social login provider**********************");
                    console.error(err);
                }
            } as SocialAuthServiceConfig,
        },
        provideHttpClient(withInterceptorsFromDi(), withFetch()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        provideCharts(withDefaultRegisterables()),
        { 
            provide: LocationStrategy, useClass: HashLocationStrategy 
        },
        //{provide: 'googleTagManagerId',  useValue: environment.googleTagManagerID},
        MsalService,
        MsalGuard,
        MsalBroadcastService      
    ] 
})

export class AppModule { }